import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    SimpleChanges,
    ViewChildren
} from '@angular/core';
import { IAirBooking } from 'libraries/service/resources/model/booking/air/IAirBooking';
import { Yii } from "libraries/interfaces/Yii";
import { IStatus } from 'libraries/service/resources/model/booking/air/IAirBookingResponse';
import { ISsr } from 'libraries/service/resources/model/booking/air/ISsr';
import {
    IBookingIdentifier,
    IGetBookingsAirResponse,
    TGetBookingResponse
} from 'libraries/service/resources/booking/interfaces/IGetBookings';
import {
    BookingResourceService,
    IQualityCheckResponse,
    IQualityCheckResult
} from 'libraries/service/resources/booking/bookingResource.service';
import { IqbaRedirectionService } from 'libraries/service/resources/redirection/IQBA/iqba-redirection.service';
import { CardComponent } from 'libraries/ui_card/card.component';
import { ITableServices } from './components/sectors/components/shared/services/table-services/table-services.service';
import { INotification, NotificationType } from "libraries/interfaces/INotification";
import { ILoader } from "libraries/component/loader/ILoader";
import { IGetEnumsService } from 'libraries/service/booking/enums/IGetEnums';
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { BookingXStatus } from "libraries/component/booking/booking-status/booking-status.service";
import { BookingType } from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import { finalize, tap } from "rxjs/operators";
import { RuntimeError } from "libraries/service/error-tracing/runtime-error.model";
import {
    IBookingHostCode,
    IImportBookingResponse
} from "libraries/service/resources/booking/interfaces/import.interface";
import { ICancelBookingResponse } from 'libraries/service/resources/booking/interfaces/ICancelBooking';
import { EAirBookingPermissions } from "libraries/component/booking-information/e-air-booking-permissions.enum";
import { AirBookingResourceService } from "libraries/service/resources/air-booking/air-booking-resource.service";
import {
    SectorAirGroupService
} from "./components/sectors/components/sectors-air/sector-air-group/sector-air-group.service";
import {
    SectorAirDeleteDialogService
} from "./components/sectors/components/sectors-air/sector-air-delete-dialog/sector-air-delete-dialog.service";
import { Observable, Subscription } from "rxjs";
import { IDeleteSectorsRequest } from 'libraries/service/resources/model/booking/air/IAirCreateBooking';
import { BookingAirToolsService } from "libraries/component/booking-information/services/booking-air-tools.service";
import { VehicleRentalBookingService } from "../../service/booking/vehicleRentalBooking.service";
import { PermissionResourceService } from "../../service/resources/permission/permissionResource.service";
import { BookingAddServicesService } from "./services/booking-add-services.service";
import {
    ResponseForConvertSearchAddOnAfx2jsonType
} from "@afidium/ts-facade/model/responseForConvertSearchAddOnAfx2jsonType";
import { ESashaPermissions } from "libraries/enums/e-sasha-permissions";
import { FareOptimisationOfferType } from "@afidium/ts-facade/model/fareOptimisationOfferType";
import { FareOptimisationType } from "@afidium/ts-facade/model/fareOptimisationType";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MenuService } from "libraries/component/booking-information/components/menu/menu.service";
import { ESectionId } from "libraries/component/booking-information/components/menu/menu.component";
import { QualityCheckToolsService } from "libraries/component/booking-information/services/quality-check-tools.service";
import { OperationType, ResponseForConvertListOperationAfx2jsonType } from "@afidium/ts-facade";

interface ICollapsibleCards {
    cardContainer: CardComponent;
}

export enum Sections {
    qualityCheckResult = 'qualityCheckResult'
}

@Component({
    selector: 'booking-information',
    template: `
        <card *ngIf="isLoading" mode='bodyOnly'>
            <loader class="card-body-content" [message]="bookingLoader.message"></loader>
        </card>
        <card *ngIf="vehicleRentalNotification?.active" mode='bodyOnly'>
            <notification class="card-body-content" [type]="vehicleRentalNotification.type"
                          [messageArray]="vehicleRentalNotification.messageArray"></notification>
        </card>

        <notification *ngIf="importNotification"
                      [type]="importNotificationType"
                      [showCloseButton]="true"
                      (onClose)="importNotification = null"
                      class="importNotification">{{importNotification}}</notification>

        <div *ngIf="addServicesLoader.active || addServicesNotification?.active" class="add-services-wrapper">
            <loader *ngIf="addServicesLoader.active" [message]="addServicesLoader.message"></loader>
            <notification *ngIf="addServicesNotification?.active"
                          [type]="addServicesNotification.type">{{addServicesNotification.message}}</notification>
        </div>

        <ng-container *ngIf="showAddServices">
            <booking-ancillary-services-page
                    [searchAddOnResponse]="searchAddOnResponse"
                    (onServiceAdd)="updateBookingAfterAddService($event)"
                    (onServiceCancel)="closeServicePage()"></booking-ancillary-services-page>
        </ng-container>

        <div [hidden]="!bookingData || showAddServices || addServicesLoader.active" #bookingDetails>
            <div class="container">
                <menu *ngIf="bookingData"
                      [code]="bookingData.code"
                      [hasServices]="hasServices"
                      [isCardsShown]="isCardsShown"
                      [booking]="bookingData"
                      [showFareOptimisation]="!!fareOptimisationData"
                      [isVehicleRentalBooking]="isVehicleRentalBooking"
                      elementInitialPositionStrategy="absolute"
                      [showServicesAndOperations]="showServicesAndOperations"
                      (onToggleCards)="toggleCards($event)"
                      (onMenuTitleClick)="clickTitleMenuToggle($event)"></menu>

                <div class="content">
                    <!-- MAIN INFORMATIONS -->
                    <booking-main-informations #bookingCard
                                               *ngIf="bookingData"
                                               class="sections"
                                               id="informations"
                                               [bookingData]="bookingData"
                                               [showBookingActions]="showBookingActions"
                                               [disableBookingActions]="isVehicleRentalBooking && !bookingExtraData"
                                               [actionLoading]="actionLoading"
                                               (onQualityCheck)="qualityCheckBooking()"
                                               (onIssue)="issueBooking()"
                                               (onCancel)="cancelBooking()"
                                               (onVoid)="voidBooking()"
                                               (onUpdate)="onUpdateBooking()"
                                               (onGetVoucher)="getBookingVoucher()"
                                               (onCardTitleClick)="clickTitleCardToggle($event)"
                                               (onModifyItinerary)="modifyItinerary()"
                                               (onAddServices)="addServices()">
                        <ng-content class="booking-information-hook" select=".booking-information-hook"></ng-content>

                        <div class="quality-check-wrapper">
                            <loader *ngIf="actionLoading" [message]="actionMessages.loading"></loader>

                            <notification *ngIf="actionSuceeded"
                                          [type]="notificationType.Info"
                                          [showCloseButton]="true"
                                          (onClose)="onActionNotificationClose()">{{actionMessages.succeeded}}</notification>

                            <notification *ngIf="actionErrored"
                                          [type]="notificationType.Error"
                                          [showCloseButton]="true"
                                          (onClose)="onErrorNotificationClose()">{{actionErroredMessage}}</notification>

                            <booking-quality-control-data *ngIf="qualityCheckResponse"
                                                          [booking]="qualityCheckResponse"
                                                          [isQualityCheckResponse]="true"
                                                          [isSummary]="true">
                            </booking-quality-control-data>
                        </div>
                    </booking-main-informations>


                    <!-- TECHNICAL INFORMATIONS -->
                    <identification #bookingCard
                                    *ngIf="bookingData"
                                    class="sections"
                                    id="identification"
                                    [bookingData]="bookingData"
                                    (onCardTitleClick)="clickTitleCardToggle($event)"></identification>

                    <!-- QUALITY CONTROL -->
                    <ng-container *permissionIf="sashaPermissions.SASHA_QUALITY_CHECK_SHOW">
                        <booking-quality-control #bookingCard
                                                 *ngIf="bookingData && bookingData?.booking && bookingData?.booking?.qualityCheck && 
                         (bookingData.booking.qualityCheck.status !== 'SUCCESS' &&
                          bookingData.booking.qualityCheck.status !== 'NO_ACTION_REQUIRED' &&
                          bookingData.booking.qualityCheck.status !== 'ACTION_PERFORMED')"
                                                 class="sections"
                                                 id="qualityControl"
                                                 [booking]="bookingData"
                                                 (onCardTitleClick)="clickTitleCardToggle($event)">
                        </booking-quality-control>
                    </ng-container>


                    <!-- OPTIMISATION -->
                    <ng-container *ngIf="fareOptimisationData">
                        <booking-fare-optimisation-card id="fareOptimisation"
                                                        class="sections"
                                                        #bookingCard
                                                        [fareOptimisation]="fareOptimisationData"
                                                        [booking]="bookingData?.booking"
                                                        [bookingSyscode]="bookingData?.syscode"
                                                        [prices]="bookingData?.booking?.priceArray"
                                                        (onUpdate)="onUpdateBooking()"
                        ></booking-fare-optimisation-card>
                    </ng-container>

                    <!-- SECTORS -->
                    <sectors #bookingCard
                             *ngIf="bookingData?.sector"
                             class="sections"
                             id="sectors"
                             [booking]="bookingData"
                             [showBookingActions]="showBookingActions"
                             [tableServices]="tableServices"
                             [serviceEnum]="serviceEnum"
                             (onCardTitleClick)="clickTitleCardToggle($event)">
                    </sectors>

                    <vehicle-rental-step *ngIf="isVehicleRentalBooking && bookingExtraData"
                                         id="sectors"
                                         [bookingExtraData]="bookingExtraData"></vehicle-rental-step>

                    <!-- TRAVELLERS -->
                    <booking-traveller-card #bookingCard
                                            *ngIf="bookingData?.traveller"
                                            class="e2e-travellers sections"
                                            id="travellers"
                                            [serviceEnum]="serviceEnum"
                                            [travellers]="bookingData.traveller"
                                            [bookingData]="bookingData"
                                            [ageDate]="lastBegin()"
                                            [ticket]="bookingData.ticketNewArray"
                                            [sector]="bookingData.sector"
                                            [isEditable]="isEditable && bookingData.xStatus !== cancelXStatus && bookingData.type?.includes(airBookingType)"
                                            (onCardTitleClick)="clickTitleCardToggle($event)"
                                            (onBookingRefreshed)="onBookingRefreshed.emit($event)"></booking-traveller-card>

                    <!-- CONTACTS -->
                    <booking-contacts #bookingCard
                                      *ngIf="bookingData"
                                      class="sections"
                                      id="contacts"
                                      [booking]="bookingData"
                                      (onCardTitleClick)="clickTitleCardToggle($event)"></booking-contacts>

                    <!-- QUALITY CONTROL -->
                    <ng-container *permissionIf="sashaPermissions.SASHA_QUALITY_CHECK_SHOW">
                        <booking-quality-control #bookingCard
                                                 *ngIf="bookingData?.booking?.qualityCheck &&
                         (bookingData.booking.qualityCheck.status !== 'SUCCESS' &&
                          bookingData.booking.qualityCheck.status !== 'NO_ACTION_REQUIRED' &&
                          bookingData.booking.qualityCheck.status !== 'ACTION_PERFORMED')"
                                                 class="sections"
                                                 id="qualityControl"
                                                 [booking]="bookingData"
                                                 (onCardTitleClick)="clickTitleCardToggle($event)">
                        </booking-quality-control>
                    </ng-container>


                    <!-- PRICE -->
                    <ng-container *ngIf="bookingData?.price?.length && showBookingPriceCard">
                        <booking-price-card
                                *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_SHOW"
                                class="sections"
                                id="price"
                                #bookingCard
                                [bookingData]="bookingData"
                                [isVehicleRentalBooking]="isVehicleRentalBooking && bookingExtraData"
                                [bookingExtraData]="bookingExtraData"
                                (onCardTitleClick)="clickTitleCardToggle($event)"></booking-price-card>
                    </ng-container>

                    <!-- WARNING onChange Fiat qlq chose => la condition bloque l'envoie de bookingExtraData !?
                    bookingData || (bookingData.type?.includes(vehicleBookingType) && bookingExtraData) => fonctionne pas
                                        <ng-container *ngIf="bookingData">
                                            <booking-price-card class="sections"
                                                                *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_SHOW"
                                                                id="price"
                                                                #bookingCard
                                                                [bookingData]="bookingData"
                                                                [isVehicleRentalBooking]="isVehicleRentalBooking"
                                                                [bookingExtraData]="bookingExtraData"
                                                                (onCardTitleClick)="clickTitleCardToggle($event)"></booking-price-card>
                                        </ng-container>
                    -->


                    <!-- REMARKS -->
                    <ng-container *ngIf="bookingData">
                        <booking-remarks #bookingCard
                                         *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_REMARKS_SHOW"
                                         class="sections"
                                         id="remarks"
                                         [bookingData]="bookingData"
                                         [isEditable]="isEditable && bookingData.xStatus !== cancelXStatus && bookingData.type?.includes(airBookingType)"
                                         (onCardTitleClick)="clickTitleCardToggle($event)"
                                         (onBookingRefreshed)="onBookingRefreshed.emit($event)"></booking-remarks>

                    </ng-container>

                    <!-- HISTORY OF ALL OPERATIONS EXECUTED ON BOOKING -->
                    <ng-container *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_OPERATIONS_SHOW">
                        <booking-operations #bookingCard
                                            *ngIf="bookingData && showServicesAndOperations"
                                            class="sections"
                                            id="bookingOperations"
                                            [bookingResult]="bookingData"
                                            (onCardTitleClick)="clickTitleCardToggle($event)"></booking-operations>
                    </ng-container>


                    <!-- SERVICES EXECUTION/ELIGIBILITY STATE -->
                    <ng-container *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_SERVICES_SHOW">
                        <booking-services #bookingCard
                                          *ngIf="bookingData && showServicesAndOperations"
                                          class="sections"
                                          id="bookingServices"
                                          [bookingResult]="bookingData"
                                          (onCardTitleClick)="clickTitleCardToggle($event)"></booking-services>
                    </ng-container>

                    <!-- SERVICES EXECUTION/ELIGIBILITY STATE -->
                    <!--  TODO JR                  *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_FARE_OPT_HISTORY_SHOW"-->
                    <!--                    <ng-container >-->
                    <!--  TODO JR                      *ngIf="showFareOptHistory"-->
                    <!--                        <booking-fare-opt-history #bookingCard-->
                    <!--                                          class="sections"-->
                    <!--                                          id="bookingFareOptHistory"-->
                    <!--                                          [bookingResult]="bookingData"-->
                    <!--                                          (onCardTitleClick)="clickTitleCardToggle($event)"></booking-fare-opt-history>-->
                    <!--                    </ng-container>-->

                    <!-- Ancillary services part, contain Flutter widget -->
                    <ng-container *ngIf="hasServices">
                        <ancillary-services-list
                                *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_ANCILLARY_SERVICES_VIEW"
                                class="sections"
                                id="ancillaryServices"
                                [hidden]="(!bookingData || !bookingWithSelection) || isLoadingServices"
                                [bookingWithSelection]="bookingWithSelection"
                                [hasAddServicesAbility]="hasAddServicesAbility"
                                (onEdit)="addServices()"></ancillary-services-list>
                        <loader *ngIf="isLoadingServices" [message]="getServicesLoader.loading"></loader>
                        <notification *ngIf="isLoadingServicesError?.active"
                                      [type]="isLoadingServicesError.type">{{isLoadingServicesError.message}}</notification>
                    </ng-container>
                </div>
            </div>
        </div>
    `,
    styles: [`
        .container {
            display: flex;
        }

        .content {
            width: calc(100% - 245px);
            margin-left: 245px;
        }

        menu {
            margin: 0;
            padding: 0;
        }

        .quality-check-wrapper, .add-services-wrapper {
            margin-bottom: .75rem;
        }

        .quality-check-wrapper notification {
            margin-top: .75rem;
        }

        .importNotification {
            margin-bottom: .75rem;
        }
    `]
})
export class BookingInformationComponent implements OnInit, OnDestroy, OnChanges {

    @Input()
    public bookingData: TGetBookingResponse;

    @Input()
    public bookingExtraData: any = null;

    @Input()
    public tableServices: ITableServices;

    @Input()
    public notification: INotification;

    @Input()
    public serviceEnum: IGetEnumsService[];

    @Input()
    public sections: { [key in Sections]: boolean };

    @Input()
    public showBookingActions: boolean = true;

    @Input()
    public showServicesAndOperations: boolean = true;

    @Input()
    public showFareOptHistory: boolean = true;

    @Input()
    public isLoading: boolean = false;

    @Input()
    public isEditable: boolean = true;

    @Input()
    public bookingWithSelection: any;
    @Input()
    public isLoadingServices: boolean;
    @Input()
    public isLoadingServicesError: INotification;

    @Input()
    public isVehicleRentalBooking: boolean;
    @Input()
    public vehicleRentalNotification: INotification;

    @Output()
    public readonly onBookingRefreshed: EventEmitter<IBookingIdentifier> = new EventEmitter<IBookingIdentifier>();

    public readonly cancelXStatus: BookingXStatus = BookingXStatus.Cancel;
    public readonly airBookingType: BookingType = BookingType.air;
    public readonly vehicleBookingType: BookingType = BookingType.vehicleRental;

    public qualityCheckResponse: ResponseForConvertListOperationAfx2jsonType;
    public sashaPermissions: typeof ESashaPermissions = ESashaPermissions;
    public error: string;
    public hasServices: boolean;

    // action related attributes
    public actionLoading: boolean;
    public actionSuceeded: boolean;
    public actionMessages: { loading: string; succeeded: string };
    public actionErrored: boolean;
    public actionErroredMessage: string;
    public booking: IAirBooking;
    public status: IStatus;
    public ssrConfig: ISsr;
    public isCardsShown: boolean = true;
    public showBookingPriceCard: boolean = false;
    public fareOptimisationData: FareOptimisationType;
    public fareOptimisationUsePermission?: boolean;
    public notificationType: typeof NotificationType = NotificationType;
    public qualityCheckResults: IQualityCheckResult[] = null;
    public context: string = 'stay';
    public bookingLoader: ILoader = {
        message: Yii.t('wui-shared-js', 'Chargement du dossier...')
    };
    public addServicesLoader: ILoader = {
        message: Yii.t('wui-shared-js', 'Récupération des services disponibles pour le dossier...'),
        active: false,
    };
    public addServicesNotification: INotification = {
        type: NotificationType.Error,
        active: false,
        message: "",
    };
    public showAddServices: boolean = false;
    public searchAddOnResponse?: ResponseForConvertSearchAddOnAfx2jsonType;
    public hasAddServicesAbility: boolean = false;
    public importNotificationType: NotificationType = NotificationType.Error;
    public importNotification: string = null;
    public airBookingPermissions: typeof EAirBookingPermissions = EAirBookingPermissions;
    @ViewChildren('bookingCard')
    public bookingCard: QueryList<ICollapsibleCards>;
    //fare optimisation
    public fareOptimisation: FareOptimisationType;

    /** "getVoucher" related messages */
    public readonly getServicesLoader: { loading: string } = {
        loading: Yii.t('wui-shared-js', "Récupération des services en cours..."),
    };

    /** "qualityCheck" related messages */
    private readonly qualityCheckMessages: { loading: string; succeeded: string; } = {
        loading: Yii.t('wui-shared-js', 'Vérification du dossier en cours...'),
        succeeded: Yii.t('wui-shared-js', 'Vérification du dossier effectuée.'),
    };

    /** "issue" related messages */
    private readonly issueMessages: { loading: string; succeeded: string } = {
        loading: Yii.t('wui-shared-js', 'Émission du dossier en cours...'),
        succeeded: Yii.t('wui-shared-js', 'Le dossier a été émis.')
    };

    /** "cancel" related messages */
    private readonly cancelMessages: { loading: string; succeeded: string } = {
        loading: Yii.t('wui-shared-js', 'Annulation du Dossier en cours...'),
        succeeded: Yii.t('wui-shared-js', 'Le Dossier a été annulé.'),
    };

    /** "void" related messages */
    private readonly voidMessages: { loading: string; succeeded: string } = {
        loading: Yii.t('wui-shared-js', 'Void du Dossier en cours...'),
        succeeded: Yii.t('wui-shared-js', 'Le Dossier a été voidé.'),
    };

    /** "getVoucher" related messages */
    private readonly getVoucherMessages: { loading: string; succeeded: string } = {
        loading: Yii.t('wui-shared-js', "Chargement du voucher en cours..."),
        succeeded: Yii.t('wui-shared-js', "Votre voucher a bien été téléchargé."),
    };

    private sectorAirDeleteRequestSubscription: Subscription = new Subscription();

    constructor(
        private readonly bookingResourceService: BookingResourceService,
        private readonly iqbaRedirectionService: IqbaRedirectionService,
        private readonly airBookingResourceService: AirBookingResourceService,
        private readonly errorTracingService: ErrorTracingService,
        private readonly sectorAirDeleteDialogService: SectorAirDeleteDialogService,
        private readonly sectorAirGroupService: SectorAirGroupService,
        private readonly bookingAirToolsService: BookingAirToolsService,
        private readonly vehicleRentalBookingService: VehicleRentalBookingService,
        private readonly permissionResource: PermissionResourceService,
        private readonly bookingAddServicesService: BookingAddServicesService,
        private readonly route: ActivatedRoute,
        private readonly menuService: MenuService,
        private readonly qualityCheckToolsService: QualityCheckToolsService,
        private readonly changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    public ngOnInit(): void {
        // https://projets2.afidium.com/issues/32308 : was impossible to delete sectors if this line wasn't commented
        //this.initHasServices();
        this.sectorAirDeleteRequestSubscription
            .add(this.sectorAirDeleteDialogService.sectorAirDeleteRequestObs
                .subscribe((deleteSectorsRequest: IDeleteSectorsRequest) => {
                    this.deleteSectors(deleteSectorsRequest);
                }))
            .add(this.sectorAirDeleteDialogService.sectorAirDeleteRefreshObs
                .subscribe(() => {
                    this.onUpdateBooking();
                })
            );

        this.permissionResource.getPermissionsStartingWith(['shared', 'stay', 'price', 'cost', 'show']).subscribe((permissions: Set<string>): void => {
            this.showBookingPriceCard = permissions.has('shared.stay.price.cost.show');
        });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes?.bookingData?.currentValue || changes?.bookingExtraData?.currentValue) {
            this.initHasServices();

            if ((this.bookingData as IGetBookingsAirResponse).booking?.fareOptimisation) {
                if (this.fareOptimisationUsePermission === undefined) {
                    this.permissionResource.getPermissionsStartingWith(['sasha', 'booking', 'air', 'fare', 'optimisation', 'use'])
                        .subscribe((permissions: Set<string>): void => {
                            this.fareOptimisationUsePermission = permissions.has('sasha.booking.air.fare.optimisation.use');
                            this.setShowFareOptimisationCard();
                        });
                } else {
                    this.setShowFareOptimisationCard();
                }
            } else {
                this.setShowFareOptimisationCard();
                this.fareOptimisationUsePermission = undefined;
            }
        }
    }

    public ngOnDestroy(): void {
        this.sectorAirDeleteRequestSubscription.unsubscribe();
        this.sectorAirGroupService.updateSectorXIds(null);
    }

    public closeServicePage(): void {
        this.showAddServices = false;
    }

    public toggleCards(isCardsShown: boolean): void {
        this.isCardsShown = isCardsShown;
        this.bookingCard.forEach(
            (bookingCard: ICollapsibleCards) => {
                const card: CardComponent = bookingCard.cardContainer;
                card.showContent = isCardsShown;
            }
        );
    }

    public qualityCheckBooking(): void {
        this.prepareAction(this.qualityCheckMessages);

        const syscode: string = this.bookingData.syscode;

        this.airBookingResourceService
            .qualityCheck(syscode, this.bookingData.host, this.bookingData.code)
            .subscribe({
                next: (value: ResponseForConvertListOperationAfx2jsonType): void => {
                    this.actionLoading = false;
                    this.qualityCheckResponse = value;
                    const operationArray: OperationType[] = this.qualityCheckToolsService.getMergedQualityCheckItems(value, this.bookingData.booking.qualityCheck);
                    if (!Boolean(this.bookingData.booking.qualityCheck)) {
                        this.bookingData.booking.qualityCheck = {
                            operationsLastPerformed: {}
                        };
                    }
                    this.bookingData.booking.qualityCheck.operationsLastPerformed.operationArray = operationArray;
                    this.bookingData.booking.qualityCheck.status = this.qualityCheckToolsService.getWorstStatusFormOperationArray(operationArray);
                    this.bookingData = {...this.bookingData};
                    this.changeDetectorRef.detectChanges();
                },
                error: (error: Error): void => this.onActionError(error)
            });
    }

    public issueBooking(): void {
        this.prepareAction(this.issueMessages);

        const syscode: string = this.bookingData.syscode;

        this.bookingResourceService
            .issue(syscode)
            .subscribe({
                next: (value: IAirBooking): void => {
                    this.onActionSuccess(value);
                },
                error: (error: Error): void => {
                    this.onActionError(error);
                }
            });
    }

    public cancelBooking(): void {
        this.prepareAction(this.cancelMessages);

        const syscode: string = this.bookingData.syscode;

        this.bookingResourceService
            .cancel(syscode)
            .subscribe({
                next: (value: ICancelBookingResponse): void => {
                    this.onActionSuccessWithRefresh(value);
                },
                error: (error: Error): void => {
                    this.onActionError(error);
                }
            });
    }

    public voidBooking(): void {
        this.prepareAction(this.voidMessages);

        const syscode: string = this.bookingData.syscode;

        this.bookingResourceService
            .void(syscode)
            .subscribe({
                next: (value: TGetBookingResponse): void => {
                    this.onActionSuccessWithRefresh(value);
                },
                error: (error: Error): void => {
                    this.onActionError(error);
                }
            });
    }

    public onUpdateBooking(): void {
        const bookingHostCode: IBookingHostCode[] = [{
            code: this.bookingData.code,
            host: this.bookingData.host
        }];
        const tempBooking: TGetBookingResponse = this.bookingData;
        this.bookingData = null;
        this.isLoading = true;
        this.bookingResourceService.importBooking(bookingHostCode).subscribe(
            (value: IImportBookingResponse) => {
                if (value.successes.length && value.successes[0] !== null) {
                    const sysCode: string = value.successes[0].syscode;
                    this.bookingResourceService.getBooking(sysCode).pipe(
                        finalize(() => {
                            this.isLoading = false;
                        })
                    ).subscribe((newBooking: TGetBookingResponse) => {
                        this.onBookingRefreshed.emit(newBooking);
                    });
                }
                if (value.warnings.length) {
                    const sysCode: string = value.warnings[0].data.syscode;
                    this.bookingResourceService.getBooking(sysCode).pipe(
                        finalize(() => {
                            this.isLoading = false;
                        })
                    ).subscribe((newBooking: TGetBookingResponse) => {
                        this.importNotificationType = NotificationType.Warning;
                        this.importNotification = value.warnings[0].message;
                        this.onBookingRefreshed.emit(newBooking);
                    });
                }
                if (value.errors.length || value.successes[0] === null) {
                    const errorMessage: string = value.errors[0]?.message ?? null;
                    this.bookingData = tempBooking;
                    this.isLoading = false;
                    this.importNotificationType = NotificationType.Error;
                    this.importNotification = [
                        Yii.t('wui-shared-js', "Impossible d'actualiser le dossier"),
                        errorMessage
                    ].join(" ");
                }
            },
            (error: string) => {
                this.bookingData = tempBooking;
                this.isLoading = false;
                this.importNotificationType = NotificationType.Error;
                this.importNotification = error;
            }
        );
    }

    public getBookingVoucher(): void {
        this.prepareAction(this.getVoucherMessages);

        let $voucherCall: Observable<Blob | string> = this.bookingResourceService.getBookingHtmlVoucherAsBlob(this.bookingData.syscode);

        if (this.bookingData.type && this.bookingData.type.includes(BookingType.vehicleRental)) {
            $voucherCall = this.bookingResourceService.getVehicleVoucher(this.bookingExtraData);
        }

        $voucherCall.pipe(
            finalize(() => this.actionLoading = false)
        ).subscribe((resultBlob: Blob | string) => {
            this.actionSuceeded = true;
            const blob: Blob = typeof resultBlob === 'string' ?
                new Blob([resultBlob], {type: "text/plain"}) :
                resultBlob;
            const blobUrl: string = window.URL.createObjectURL(blob);
            const link: HTMLAnchorElement = document.createElement('a');
            link.id = 'voucherDownloadLink'; // for debugging purpose only
            link.href = blobUrl;
            link.download = `${this.bookingData.syscode}_voucher.html`;
            link.target = '_blank';
            link.click();
            window.URL.revokeObjectURL(blobUrl);
            this.onActionSuccess(null);
        }, (error: Error) => {
            this.onActionError(new RuntimeError(
                Yii.t('wui-shared-js', "Impossible d'obtenir le voucher"),
                error
            ));
        });
    }

    public modifyItinerary(): void {
        // create request => get mock ID later
        const jsonBody = this.iqbaRedirectionService.createIQBABody(this.bookingData);
        this.iqbaRedirectionService.redirectToIQBA(jsonBody);
    }

    public addServices(): void {
        window.scrollTo({top: 0, behavior: 'smooth'});
        this.addServicesLoader.active = true;
        this.bookingAddServicesService
            .addServices(this.bookingData, this.bookingWithSelection)
            .pipe(
                finalize((): boolean => this.addServicesLoader.active = false)
            ).subscribe(
            {
                next: (response: ResponseForConvertSearchAddOnAfx2jsonType): void => {
                    if (response) {
                        this.addServicesNotification.active = false;
                        this.showAddServices = true;
                        this.searchAddOnResponse = response;
                        return;
                    }
                    this.addServicesNotification.active = true;
                    this.addServicesNotification.type = NotificationType.Warning;
                    this.addServicesNotification.message = Yii.t('wui-shared-js', 'Aucun service n\'est disponible à l\'ajout.');
                    this.showAddServices = false;
                },
                error: (err: Error): void => {
                    this.addServicesNotification.active = true;
                    this.addServicesNotification.type = NotificationType.Error;
                    this.addServicesNotification.message = err.message;
                    this.showAddServices = false;
                    console.error(err);
                }
            });
    }

    public onActionNotificationClose(): void {
        this.actionSuceeded = false;
        this.actionMessages = null;
    }

    public onErrorNotificationClose(): void {
        this.actionErrored = false;
        this.actionErroredMessage = null;
    }

    public lastBegin(): string {
        if ((this.bookingData as IGetBookingsAirResponse).sector) {
            return (this.bookingData as IGetBookingsAirResponse).sector[(this.bookingData as IGetBookingsAirResponse).sector.length - 1].begin;
        }
        return '';
    }

    public clickTitleCardToggle(name: string): void {
        this.bookingCard?.forEach((bookingCard: { name: string; cardContainer: CardComponent; }): void => {
            if (bookingCard.name === name) {
                const card: CardComponent = bookingCard.cardContainer;
                card.showContent = !card.showContent;
            }
        });
    }

    public clickTitleMenuToggle(name: string): void {
        this.bookingCard.forEach((bookingCard: { name: string; cardContainer: CardComponent; }): void => {
            if (bookingCard.name === name) {
                const card: CardComponent = bookingCard.cardContainer;
                if (!card.showContent) {
                    card.showContent = !card.showContent;
                }
            }
        });
    }

    public updateBookingAfterAddService(booking: IGetBookingsAirResponse): void {
        this.closeServicePage();
        this.bookingData = booking;
        this.bookingWithSelection = booking;
        this.initHasServices();
        this.changeDetectorRef.detectChanges();
    }

    /**
     * When action ends successfully.
     * @param booking current booking
     */
    private onActionSuccess(booking: IAirBooking | null): void {
        this.actionLoading = false;
        this.actionSuceeded = true;
        if (booking) {
            this.booking = booking;
        }
    }

    /**
     * When action ends successfully.
     * @param booking current booking
     */
    private onActionSuccessWithRefresh(booking: IBookingIdentifier): void {
        this.actionLoading = false;
        this.actionSuceeded = true;
        this.onBookingRefreshed.emit(booking);
    }

    /**
     * When action ends in error.
     * @param error what went wrong
     */
    private onActionError(error: Error): void {
        this.actionErrored = true;
        this.actionLoading = false;
        this.actionErroredMessage = error.message;
        this.errorTracingService.captureException(error);
    }

    private prepareAction(messages: { loading: string; succeeded: string }): void {
        this.actionLoading = true;
        this.actionSuceeded = false;
        this.actionErrored = false;

        this.actionMessages = messages;
        this.actionErroredMessage = null;
    }

    private async deleteSectors(deleteSectorsRequest: IDeleteSectorsRequest): Promise<void> {
        await this.bookingResourceService.deleteBookingSectors(deleteSectorsRequest.booking.syscode, 'sectors', deleteSectorsRequest).toPromise()
            .then(res => {
                if (res && res[0]) {
                    this.bookingData = res[0];
                    this.sectorAirDeleteDialogService.response(true);
                    this.sectorAirGroupService.updateSectorXIds(null);
                } else {
                    this.sectorAirDeleteDialogService.response(false);
                }
            })
            .catch(err => {
                this.sectorAirDeleteDialogService.response(false, err);
            });
    }

    private initHasServices(): void {
        this.hasServices = this.isVehicleRentalBooking ? this.vehicleRentalBookingService.hasServices(this.bookingExtraData) :
            this.bookingAirToolsService.hasServices(this.bookingData as IGetBookingsAirResponse) ||
            this.bookingAirToolsService.hasServicesNewFormat(this.bookingData);

        this.permissionResource.hasPermission(EAirBookingPermissions.SHARED_AIR_BOOKING_SERVICES_ADD)
            .subscribe((hasAddServicesPermission: boolean) => {
                this.hasAddServicesAbility = this.bookingAirToolsService.canAddServices(
                    hasAddServicesPermission,
                    this.bookingData,
                    this.bookingAirToolsService.isOneSectorLowCost(this.bookingData)
                );
            });
    }

    private setShowFareOptimisationCard(): void {
        if (this.fareOptimisationUsePermission &&
            this.bookingData.type?.includes(this.airBookingType) &&
            this.bookingData?.price?.length) {
            this.fareOptimisationData = (this.bookingData as IGetBookingsAirResponse).booking.fareOptimisation;
            this.route.params.subscribe(
                (params: Params): void => {
                    if (params.offerId) {
                        setTimeout((): void => {
                                this.menuService.goToAnchorSubject.next(ESectionId.fareOptimisation);
                            },
                            400);
                    }
                }
            );
        } else {
            this.fareOptimisationData = null;
        }
    }
}
